import React from 'react';
import './Event.css';

import { extractDateParts } from '../../utils';

import { FaClock, FaMapMarkerAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';



const Event = ({ event }) => {

  const { image, title } = event; // Extracting data from event object
  const { day, shortMonth, weekday } = extractDateParts(event.details.date); // Extracting formatted date parts (day, short month, weekday)

  return (
    <div className='event-item'>

      <img src={image} alt={title} /> {/* Event image */}

      <div className='content'>

        <div className="date">{weekday} <span>{day}</span> {shortMonth}</div> {/* Displaying formatted date */}

        <div className='text'>
          {/* Link to event details page */}
          <Link to={`/Events/${title}`} state={event} className='main-heading'>
            {title} {/* Event title */}
          </Link>

          <div className='details'>
            <h3><FaClock className='icon' /><span>{event.details.time}</span></h3> {/* Event time */}
            <h3><FaMapMarkerAlt className='icon' /> <span>{event.details.location}</span></h3> {/* Event venue */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Event;
